import * as React from "react";
import { SecondaryHeadingContent } from "../../SecondaryHeadingContent";
import { SecondaryHeading } from "../../SecondaryHeading";
import { HeadingTitle } from "../../HeadingTitle";
import { RenderMarketNames } from "../../RenderComponents/RenderMarketNames";
export class AmericanStyle extends SecondaryHeadingContent {
    /* istanbul ignore next */
    /* super transpiles to  var _this = _super.call(this) || this; */
    constructor(props) {
        super(props);
    }
    renderSubheading() {
        return React.createElement(SecondaryHeading, { key: `subheading-${this.props.id}`, componentPrefix: this.props.cardType },
            React.createElement(HeadingTitle, { name: this.props.name, eventsCount: this.props.eventsCount }),
            this.props.marketNames.length
                ? React.createElement(RenderMarketNames, { marketNames: this.props.marketNames, marketTemplates: this.props.marketTemplates })
                : "");
    }
}
//# sourceMappingURL=AmericanStyle.js.map